export enum UserRoleKey {
  SuperAdmin = 'superAdmin',
  Admin = 'admin',
  Member = 'member',
  Unkown = 'unknown',
}
